var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-component": _vm.$options.name } },
    [
      _c("jade-navigation-bar", {
        attrs: {
          background: "body",
          navigateType: "back",
          label: _vm.$t("navigate"),
        },
        on: { onNavigate: _vm.redirectToCompany },
      }),
      _c(
        "section",
        { staticClass: "container" },
        [
          _c(
            "jade-alert",
            {
              attrs: {
                showIcon: "",
                variant: "warning",
                icon: "warning",
                title: _vm.$t("title"),
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("description")) + " ")]
          ),
          _c("secret-keys"),
        ],
        1
      ),
      _c("app-footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }